import { Component, Input, Output, ViewChild, EventEmitter, ViewContainerRef, OnInit } from '@angular/core';
import { ICellChangedEvent } from './cellValueChanged.event';
import { IColumn } from './column.interface';

@Component( {
    selector: 'app-yesno',
    templateUrl: 'yesno.component.html',
    styleUrls: ['yesno.component.css']
})

export class YesNoEditorComponent implements OnInit {

    @Input() row: any;
    @Input() col: IColumn;
    @Input() val: boolean;
    @Output() checkChanged = new EventEmitter<ICellChangedEvent>();
    @ViewChild( 'input', { read: ViewContainerRef }) private input;

    callback: Function;

    takeFocus( callback?: Function ) {
        // this.input.element.nativeElement.focus();
        // setTimeout(() => {
        //     this.input.element.nativeElement.select();
        // }, 1 );
        // if (callback) {
        //     this.callback = callback;
        // }
    }

    // getValue() {
    //     return +this.val;
    // }

    onChanged(e) {
        this.checkChanged.emit({
                row: this.row,
                col: this.col,
                oldValue: null,
                newValue: this.input.element.nativeElement.checked,
                cancel: null
            } );
    }    

    ngOnInit(): void {
        this.takeFocus();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Grid/yesno.component.ts